import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {DatePipe} from '@angular/common';
import { Subscription } from 'rxjs';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';
@Component({
  selector: 'app-table-column-name',
  templateUrl: './table-column-name.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css'],
  providers: [TaskService, DatePipe]
})
export class TableColumnNameComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

  ngOnInit(): void {
  }
}
